import { FC, useCallback, useEffect, useReducer, useState } from 'react';

import {
  getDebugLogEntries,
  getDebugNameFlag,
  getDebugStorageDisplay,
  getDebugSttDisplay,
  sophieDebugClearStorage,
  sophieDebugLog,
  sophieDebugSubscribe,
} from 'store/assistant/sophieDebug';

import * as S from './SophieDebugPanel.styles';

export const SophieDebugPanel: FC<{ showBug: boolean }> = ({ showBug }) => {
  const [panelOpen, setPanelOpen] = useState(false);
  const [, forceUpdate] = useReducer((x: number) => x + 1, 0);

  useEffect(() => {
    return sophieDebugSubscribe(() => forceUpdate());
  }, []);

  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      sophieDebugLog(
        '❗ JS ERROR: ' + e.message + ' @ ' + (e.filename || '').split('/').pop() + ':' + e.lineno
      );
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      sophieDebugLog('❗ PROMISE ERROR: ' + (e.reason?.message || e.reason || 'unknown'));
    };
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  const togglePanel = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setPanelOpen((prev) => !prev);
  }, []);

  const closePanel = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPanelOpen(false);
  }, []);

  const clearLs = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    sophieDebugClearStorage();
  }, []);

  const entries = getDebugLogEntries();

  return (
    <>
      {showBug && <S.DebugButton onClick={togglePanel}>🐛</S.DebugButton>}

      <S.Panel $open={panelOpen}>
        <S.PanelHeader>
          <S.PanelTitle>SOPHIE DEBUG v43</S.PanelTitle>
          <span>
            <S.ClearButton onClick={clearLs}>Clear LS</S.ClearButton>
            <S.CloseButton onClick={closePanel}>✕</S.CloseButton>
          </span>
        </S.PanelHeader>

        <S.Section>
          <S.SectionLabel>localStorage:</S.SectionLabel>
          <S.StorageContent>{getDebugStorageDisplay()}</S.StorageContent>
        </S.Section>

        <S.Section>
          <S.SectionLabel>STT buffer:</S.SectionLabel>
          <S.SttContent>{getDebugSttDisplay()}</S.SttContent>
        </S.Section>

        <S.Section>
          <S.SectionLabel>nameDetected:</S.SectionLabel> <span>{getDebugNameFlag()}</span>
        </S.Section>

        <div>
          {entries.map((entry, i) => (
            <S.LogEntry key={i}>
              {entry.ts} {entry.msg}
            </S.LogEntry>
          ))}
        </div>
      </S.Panel>
    </>
  );
};
